import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Main from './(pages)/main/page'

const CreateCall = () => {
  return (
    <Routes>
        <Route path="*" element={<Main />} />
    </Routes>
  )
}

export default CreateCall